<template>
  <div id="chart-line-item-item-box">
    <chart-title
      leftTitle="PDM日销售数据 center_3"
      :rightTitle="`周合计：${total_money}`"
      :tooltipText="'开单提交实时金额数据，不含本厂责任售后'"
    ></chart-title>
    <div class="two_col">
      <date-change-card
        height="50%"
        @leftClick="leftClick(1)"
        @rightClick="rightClick(1)"
      >
        <div id="center_2" slot="main" />
      </date-change-card>
      <div class="center_3_header">
        {{ formatTime(monthDate, "yyyy年MM月") }} 合计：{{ all_month_money }}
      </div>
      <date-change-card
        height="48%"
        @leftClick="leftClick(2)"
        @rightClick="rightClick(2)"
      >
        <div id="center_3" slot="main" />
      </date-change-card>
    </div>
  </div>
</template>

<script>
import { monthlySalesData } from "@/api/cockpit/jyl";
import {
  formatTime,
  getNextMonth,
  getNextDate,
  getFirstDate,
  arrDataFormat,
} from "@/utils/index";
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
export default {
  mixins: [resize],
  name: "center_2",
  components: { ChartTitle, DateChangeCard },
  data() {
    return {
      chart: null,
      chart3: null,
      total_money: 0,
      all_month_money: 0,
      weekDayData: [],
      monthDayData: [],
      weekDate: new Date(),
      monthDate: new Date(),
    };
  },
  props: {},
  created() {},
  mounted() {
    this.getData(this.weekDate, 3);
  },

  beforeDestroy() {
    if (!this.chart && !this.chart3) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
    this.chart3.dispose();
    this.chart3 = null;
  },
  methods: {
    formatTime,
    //获取数据  type 1:获取周统计，每日三个销售公司销售额;type 2:获取月统计，三个销售公司每日销售总额；type：3 获取周和月的的每日数据
    getData(date, type) {
      monthlySalesData({
        add_time: formatTime(date, "yyyy-MM-dd"),
        type: "day",
      }).then((resp) => {
        if (type == 1) {
          this.weekDayData = arrDataFormat(resp.data.list);
          this.total_money = resp.data.total_money;
        } else if (type == 2) {
          this.monthDayData = arrDataFormat(resp.data.all_month);
          this.all_month_money = resp.data.all_month_money;
        } else {
          this.weekDayData = arrDataFormat(resp.data.list);
          this.monthDayData = arrDataFormat(resp.data.all_month);
          this.total_money = resp.data.total_money;
          this.all_month_money = resp.data.all_month_money;
        }

        this.initChart();
      });
    },
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("center_2"));
      this.setOptions();
      this.chart3 = this.$echarts.init(document.getElementById("center_3"));
      this.setOptions3();
    },
    //处理日期排序问题
    objectOrder(obj) {
      const arr = arrDataFormat(obj);
      return arr.sort(function (a, b) {
        return new Date(a.name).getTime() - new Date(b.name).getTime();
      });
    },

    setOptions() {
      if (
        !this.weekDayData ||
        !this.weekDayData.length ||
        this.weekDayData.length < 4
      ) {
        return;
      }
      //获取日合计最大的数据
      const daySum = this.weekDayData.find((m) => m.name == "日合计");
      let maxMonth = "";
      if (daySum) {
        maxMonth = arrDataFormat(daySum.value).sort(
          (a, b) => b.value - a.value
        )[0];
      }
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        grid: {
          left: "12%",
          right: "12%",
          top: "12%",
          bottom: "20%",
          containLabel: true,
        },
        legend: {
          data: this.weekDayData.map((m) => m.name),
          bottom: "6%",
          textStyle: {
            color: "#C0C4CC",
            fontSize: "10",
          },
        },
        xAxis: [
          {
            type: "category",
            data: this.objectOrder(this.weekDayData[0].value).map(
              (m) => m.name
            ),
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              color: "#909399",
              fontSize: "10",
            },
            axisLine: {
              lineStyle: {
                color: "#606266",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            // interval: 50,
            axisLabel: {
              color: "#606266",
              fontSize: "10",
            },
            axisLine: {
              lineStyle: {
                color: "#606266",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#606266",
                type: "dashed", //设置网格线类型 dotted：虚线 solid:实线
              },
            },
          },
          {
            type: "value",
            // name: "日合计",
            // min: 0,
            // max: 25,
            // interval: 5,
            axisLabel: {
              color: "#606266",
              fontSize: "10",
            },
            axisLine: {
              lineStyle: {
                color: "#606266",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#606266",
              },
            },
          },
        ],
        series: [
          {
            name: this.weekDayData[0].name,
            type: "bar",
            data: this.objectOrder(this.weekDayData[0].value).map(
              (m) => m.value
            ),
            barWidth: 5,
            itemStyle: {
              borderRadius: 5,
              color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                { offset: 0, color: "rgba(21,157,255,0.1)" },
                { offset: 1, color: "rgba(21,157,255,1)" },
              ]),
            },
          },
          {
            name: this.weekDayData[1].name,
            type: "bar",
            data: this.objectOrder(this.weekDayData[1].value).map(
              (m) => m.value
            ),
            barWidth: 5,
            itemStyle: {
              borderRadius: 5,
              color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                { offset: 0, color: "rgba(34,228,255,0.1)" },
                { offset: 1, color: "rgba(34,228,255,1)" },
              ]),
            },
          },
          {
            name: this.weekDayData[2].name,
            type: "bar",
            data: this.objectOrder(this.weekDayData[2].value).map(
              (m) => m.value
            ),
            barWidth: 5,
            itemStyle: {
              borderRadius: 5,
              color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                { offset: 0, color: "rgba(59, 255, 208,0.1)" },
                { offset: 1, color: "rgba(59, 255, 208,1)" },
              ]),
            },
          },
          {
            name: this.weekDayData[3].name,
            type: "line",
            data: this.objectOrder(this.weekDayData[3].value).map(
              (m) => m.value
            ),
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                { offset: 0, color: "rgba(175, 238, 238,0.1)" },
                { offset: 1, color: "rgba(175, 238, 238,1)" },
              ]),
            },
          },
          {
            name: "日合计",
            type: "effectScatter",
            coordinateSystem: "cartesian2d",
            data: [
              {
                value: [maxMonth.name, maxMonth.value],
                symbolSize: 9,
              },
            ],
            showEffectOn: "render",

            rippleEffect: {
              brushType: "stroke",
            },
            hoverAnimation: true,
            itemStyle: {
              normal: {
                color: "rgba(255,255,255,0.9)",
                shadowBlur: 38,
                shadowColor: "rgba(255,255,255,0.9)",
              },
            },
            zlevel: 1,
            tooltip: {
              show: false,
            },
          },
        ],
      });
    },
    setOptions3() {
      const color = ["0, 157, 255", "34, 228, 255", "59, 255, 208"];
      const data = this.monthDayData.map((m, i) => {
        return {
          value: m.value,
          itemStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
              { offset: 0, color: `rgba(${color[i % 3]},0.1)` },
              { offset: 1, color: `rgba(${color[i % 3]},1)` },
            ]),
          },
        };
      });
      const valArr = this.monthDayData.map((m) => m.value);
      const maxNum = Math.max(...valArr) + 10;
      this.chart3.setOption({
        color: ["#009dff", "#22e4ff", "#3bffd0"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        grid: {
          left: "12%",
          right: "12%",
          top: "6%",
          bottom: "15%",
          containLabel: true,
        },
        legend: {
          show: false,
        },
        xAxis: [
          {
            type: "category",
            data: this.monthDayData.map((m) => m.name),
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              color: "#909399",
              fontSize: "10",
            },
            axisLine: {
              lineStyle: {
                color: "#606266",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            max: maxNum,
            min: 0,
            interval: Math.round((maxNum / 8) * 10000) / 10000,
            axisLabel: {
              color: "#606266",
              fontSize: "10",
            },
            axisLine: {
              lineStyle: {
                color: "#606266",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#606266",
                type: "dashed", //设置网格线类型 dotted：虚线 solid:实线
              },
            },
          },
          {
            show: false,
          },
        ],
        series: [
          {
            name: "销售额",
            type: "bar",
            barWidth: 5,
            itemStyle: {
              borderRadius: 5,
            },
            data: data,
          },
        ],
      });
    },
    //前一月
    leftClick(type) {
      if (type == 1) {
        this.weekDate = getNextDate(
          formatTime(this.weekDate, "yyyy-MM-dd"),
          -7
        );
        this.getData(this.weekDate, type);
      } else {
        this.monthDate = getNextMonth(
          formatTime(this.monthDate, "yyyy-MM-dd"),
          -1
        );
        this.getData(this.monthDate, type);
      }
    },
    //后一月
    rightClick(type) {
      if (type == 1) {
        this.weekDate = getNextDate(
          formatTime(this.weekDate, "yyyy-MM-dd"),
          +7
        );
        this.getData(this.weekDate, type);
      } else {
        this.monthDate = getNextMonth(
          formatTime(this.monthDate, "yyyy-MM-dd"),
          +1
        );
        this.getData(this.monthDate, type);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 55vh;
  .two_col {
    padding: 0 10px;
    height: calc(100% - 30px);
  }
  .center_3_header {
    color: #ffffff;
    text-align: right;
    font-weight: bolder;
    padding: 0 10px;
    margin-top: 5px;
  }
  #center_2 {
    height: 100%;
  }
  #center_3 {
    height: 100%;
  }
}
</style>
